import React from 'react';
import MediaQuery from 'react-responsive';
import ReactPlayer from 'react-player';
import styled from 'styled-components';
//
import { reactPlayerGiffer } from 'helpers';
//
const Wrap = styled.div``;

export default ({ url }) => {
  if (typeof document === 'undefined') {
    return <Wrap />;
  }

  return (
    <MediaQuery minWidth={769}>
      {matches => (
        <Wrap>
          <ReactPlayer
            className="react-player"
            height="100%"
            loop
            muted
            playing={matches}
            width="100%"
            url={reactPlayerGiffer(url)}
          />
        </Wrap>
      )}
    </MediaQuery>
  );
};
